import axios from "axios";
import {authHeaderForPhotos} from "./auth-header";

const API_URL = process.env.REACT_APP_API_URL_AUTH;

const register = (data) => {
    return axios.post(API_URL + "signup", data, {
     headers: authHeaderForPhotos(data)});
};

const login = (username, password) => {
    return axios
        .post(API_URL + "signin", {
            username,
            password,
        })
        .then((response) => {
            if (response.data.accessToken) {
                localStorage.setItem("user", JSON.stringify(response.data));
            }

            return response.data;
        });
};

const refreshCurrentUser = () => {
    const current = getCurrentUser();
    if (!current?.accessToken) return Promise.reject(new Error("No active session"));

    return axios.get(API_URL + "me", {headers: {"x-access-token": current.accessToken}}).then((response) => {
        const refreshed = {...current, ...response.data, accessToken: current.accessToken};
        localStorage.setItem("user", JSON.stringify(refreshed));
        return refreshed;
    });
};

const logout = () => {
    localStorage.removeItem("user");
};

const getCurrentUser = () => {
    return JSON.parse(localStorage.getItem("user"));
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    register,
    login,
    refreshCurrentUser,
    logout,
    getCurrentUser,
};